import React, { useMemo, useState } from "react";
import { BsCaretDownFill, BsCaretRightFill, BsHouseFill, BsGeoAltFill, BsBookmarkCheckFill, BsStarFill } from "react-icons/bs";

const HealthCenterKPI = ({ centers = [], showKPIs = true }) => {
  const [showKPI, setShowKPI] = useState(showKPIs);

  const kpis = useMemo(() => {
    if (!centers || centers.length === 0) {
      return {
        totalCenters: 0,
        totalUniqueCities: 0,
        totalUniqueServices: 0,
        avgRating: 0
      };
    }

    const totalCenters = centers.length;

    const uniqueCities = [...new Set(centers.map(c => c.city?.trim()))].filter(Boolean);
    const totalUniqueCities = uniqueCities.length;

    const allServices = centers.flatMap(c => c.services || []);
    const uniqueServices = [...new Set(allServices.map(s => s.trim()))].filter(Boolean);
    const totalUniqueServices = uniqueServices.length;

    const avgRating = (
      centers.reduce((sum, c) => sum + (c.rating || 0), 0) / (centers.length || 1)
    ).toFixed(1);

    return {
      totalCenters,
      totalUniqueCities,
      totalUniqueServices,
      avgRating
    };
  }, [centers]);

  const formatNumber = (value) => {
    if (typeof value === 'number') {
      return value.toLocaleString();
    }
    return value;
  };

  const toggleKPI = () => setShowKPI(prev => !prev);

  const kpiCards = [
    {
      title: "Total Centers",
      value: kpis.totalCenters,
      icon: <BsHouseFill />,
      iconColor: "#E4E4FF"
    },
    {
      title: "Unique Cities",
      value: kpis.totalUniqueCities,
      icon: <BsGeoAltFill />,
      iconColor: "#E4E4FF"
    },
    {
      title: "Unique Services",
      value: kpis.totalUniqueServices,
      icon: <BsBookmarkCheckFill />,
      iconColor: "#E4E4FF"
    },
    {
      title: "Average Rating",
      value: kpis.avgRating,
      icon: <BsStarFill />,
      iconColor: "#E4E4FF"
    }
  ];

  return (
    <>
      {/* <div className="d-flex align-items-center justify-content-between mb-3 mt-4">
        <div className="d-flex align-items-center">
          <h5 className="mb-0 me-3">Dashboard / Health Centers</h5>
          <button onClick={toggleKPI} className="btn text-primary p-0">
            {showKPI ? "Hide KPI " : "Show KPI "}
            {showKPI ? <BsCaretDownFill size={12} /> : <BsCaretRightFill size={12} />}
          </button>
        </div>
      </div> */}

      {showKPI && (
        <div className="row gy-3 introbx_row">
          {kpiCards.map((kpi, index) => (
            <div key={index} className="col">
              <div className="d-flex align-items-center gap-2 p-3 rounded-10 shadow-sm">
                <div
                  className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: '2rem',
                    height: '2rem',
                    backgroundColor: '#E4E4FF',
                    color: '#8381FF'
                  }}
                >
                  <span className="d-block material-symbols-outlined fs-lg">{kpi.icon}</span>
                </div>
                <div className="info flex-fill">
                  <p className="fs-sm text-gray mb-0">{kpi.title}</p>
                  <p className="lh-1 fw-semibold">{formatNumber(kpi.value)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default HealthCenterKPI;